import React, { useCallback, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Hero from "./Hero";
import Navbar from "./Navbar";
import Footer from "./Footer";
import QuoteDialog from "./QuoteDialog";
import CartDrawer from "./CartDrawer";

// Scrolls to top on page change, or to the anchor when the URL has a hash
// (e.g. /#produits from the navbar while on another page).
const ScrollManager = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const t = setTimeout(() => {
                document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
            }, 80);
            return () => clearTimeout(t);
        }
        window.scrollTo({ top: 0 });
    }, [pathname, hash]);
    return null;
};

const PublicLayout = () => {
    const [quoteOpen, setQuoteOpen] = useState(false);
    const [quoteProduct, setQuoteProduct] = useState("");

    const openQuote = useCallback((product = "") => {
        setQuoteProduct(product || "");
        setQuoteOpen(true);
    }, []);

    return (
        <div className="min-h-screen bg-[#FBFBFD] text-neutral-900 antialiased">
            <ScrollManager />
            {/* Bandeau livraison : NON sticky, il défile avec la page.
                Seule la navbar reste collée en haut (sticky top-0 dans Navbar).
                Les deux restent HORS du conteneur overflow-x-hidden, sinon
                position: sticky ne s'engage jamais. */}
            <Hero />
            <Navbar onQuoteClick={() => openQuote()} />
            <div className="overflow-x-hidden">
                <Outlet />
                {/* Footer monté ici : présent sur toutes les pages publiques
                    (home, /produits, /categorie/*, /produit/*, /offres), pas sur /admin. */}
                <Footer />
                <QuoteDialog
                    open={quoteOpen}
                    onOpenChange={setQuoteOpen}
                    defaultProduct={quoteProduct}
                />
                <CartDrawer />
                <Toaster richColors position="bottom-right" />
            </div>
        </div>
    );
};

export default PublicLayout;
